import { RoomInfo } from '../types/app-types';

export const isRoomEqual = (a: RoomInfo, b: RoomInfo) => {
  if (!a || !b) return false;

  return (
    a.status === b.status &&
    a.winnerStatus === b.winnerStatus &&
    a.closer === b.closer &&
    a.roundCounter === b.roundCounter &&
    a.data.roomId === b.data.roomId &&
    a.data.playerA === b.data.playerA &&
    a.data.playerB === b.data.playerB &&
    a.data.wins === b.data.wins &&
    a.data.token === b.data.token &&
    a.data.bet === b.data.bet &&
    a.pot === b.pot &&
    a.winsCounter.winsPlayerA === b.winsCounter.winsPlayerA &&
    a.winsCounter.winsPlayerB === b.winsCounter.winsPlayerB &&
    a.deadline === b.deadline
  );
};

export const chunksSplit = <T>(arr: T[], size: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};
